import {createTheme} from '@mantine/core';

// Platform default theme. Every app is forked from this skeleton and owns its
// copy of this file, so edit it per app after forking.
//
// `flexinet` is a real light-to-dark ramp, not ten copies of one colour.
// Mantine 9's light variant tints with the low shades and writes text in the
// high ones; with ten identical shades the text matched its background (a blank
// active NavLink). Index 6 stays the brand colour #194a74, so filled components
// keep their look.
export const theme = createTheme({
    fontFamily: 'Inter',
    primaryColor: 'flexinet',
    primaryShade: {light: 6, dark: 6},
    colors: {
        flexinet: [
            '#edf1f4',
            '#d6dee6',
            '#b5c5d3',
            '#91a8bc',
            '#6c8ba6',
            '#426b8d',
            '#194a74',
            '#164064',
            '#123554',
            '#0e2b43',
        ],
    },
    headings: {
        fontFamily: 'Inter',
        fontWeight: '400',
    },
});
